<div class="modal-header">
  <h2 class="modal-title">Sélection du dossier SharePoint</h2>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <!-- Breadcrumb -->
  <nav class="mb-2">
    <ng-container *ngFor="let bc of breadcrumb; let i = index">
      <a *ngIf="i < breadcrumb.length - 1"
         class="breadcrumb-link"
         (click)="navigateToBreadcrumb(i)">
        <span class="breadcrumb-item">{{ bc.name }}</span>
      </a>
      <span class="breadcrumb-item" *ngIf="i === breadcrumb.length - 1">{{ bc.name }}</span>
      <span *ngIf="i < breadcrumb.length - 1"> > </span>
    </ng-container>
  </nav>

  <!-- Barre recherche + tri -->
  <div class="search-sort d-flex align-items-center mb-2">
    <input type="text"
          class="form-control search-input"
          placeholder="Rechercher un dossier..."
          [(ngModel)]="searchTerm"
          (input)="applyFilterAndSort()"
          [disabled]="loading" />

    <button class="btn btn-secondary"
            (click)="toggleSort()"
            [title]="sortAscending ? 'Trier Z → A' : 'Trier A → Z'">
      <i class="bi" [ngClass]="sortAscending ? 'bi-sort-alpha-down' : 'bi-sort-alpha-up'"></i>
    </button>
  </div>

  <!-- Création dossier -->
  <button class="btn btn-sm btn-outline-primary"
          (click)="startCreateFolder()"
          [disabled]="loading">
    ➕ Nouveau dossier
  </button>
  <div *ngIf="creatingFolder" class="create-folder mt-2">
    <input type="text"
          class="form-control form-control-sm"
          placeholder="Nom du dossier"
          [(ngModel)]="newFolderName"
          (keyup.enter)="createFolder()" />

    <div class="actions">
      <button class="btn btn-sm btn-success" (click)="createFolder()">
        Créer
      </button>

      <button class="btn btn-sm btn-secondary"
              (click)="creatingFolder = false">
        Annuler
      </button>
    </div>
  </div>

  <!-- Chargement -->
  <div *ngIf="loading" class="spinner-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Chargement...</span>
    </div>
  </div>

  <!-- Liste en lignes -->
  <div *ngIf="!loading" class="folder-list-container">
    <div class="folder-grid">

      <div class="folder-row"
          *ngFor="let folder of filteredItems"
          [class.selected]="selectedFolder?.id === folder.id"
          (click)="selectFolder(folder)"
          (dblclick)="openFolder(folder)">

        <span class="folder-icon">📁</span>
        <span class="folder-name">{{ folder.name }}</span>

      </div>

    </div>
  </div>

  <div *ngIf="!loading && filteredItems.length === 0">
    Aucun dossier.
  </div>


</div>

<div class="modal-footer">
  <button class="btn btn-secondary"
          (click)="activeModal.dismiss()">
    Annuler
  </button>

  <button class="btn btn-primary"
          [disabled]="!selectedFolder"
          (click)="confirmSelection()">
    Sélectionner
  </button>
</div>
